import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import api from "helpers/api";
import endpoints from "helpers/endpoints";
import Software from "types/Software.type";

const fetchSoftwares = async ({ queryKey }) => {
  const fetchOptions = queryKey[2];
  return api({
    method: "get",
    url: endpoints.Softwares,
    params: { ...fetchOptions }
  });
};

const deleteSoftware = async (data) => {
  return api({
    method: "delete",
    url: endpoints.DeleteSoftware(data.softwareId)
  });
};

function useDeleteSoftware(onDeleteSoftware) {
  return useMutation({
    mutationFn: deleteSoftware,
    onSettled: onDeleteSoftware,
    meta: {
      errorMessage: "E.SOFTWARE-002"
    }
  });
}

function useSoftwares(fetchOptions) {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: ["software", "list", fetchOptions],
    queryFn: fetchSoftwares,
    select: (data): { softwareDetail: Software[]; totalRecords: number } => {
      if (data.data) {
        return data.data;
      } else {
        return { softwareDetail: [], totalRecords: 1 };
      }
    },
    initialData: () => {
      return queryClient.getQueryData(["software", "list"], {
        exact: false,
        type: "active"
      });
    },
    meta: {
      errorMessage: "E.SOFTWARE-001"
    },
    keepPreviousData: true
  });
}

const uploadSoftware = ({ data, onUploadProgress }) => {
  return api({
    url: endpoints.UploadSoftware,
    method: "post",
    headers: { "Content-Type": "multipart/form-data" },
    data,
    onUploadProgress
  });
};

function useUploadSoftware(onSuccessfulUpload) {
  return useMutation({
    mutationFn: uploadSoftware,
    onSettled: onSuccessfulUpload,
    meta: { errorMessage: "E.SOFTWARE-003" }
  });
}

const useUpdateSoftware = (onSoftwareUpdated) => {
  return useMutation({
    mutationFn: (data: any) => {
      return api({
        url: endpoints.Softwares,
        params: { id: data.softwareId },
        method: "put",
        data: {
          machineUses: data.machineUses,
          softwareVersion: data.softwareVersion,
          softwarePartId: data.softwarePartId,
          softwareConfiguration: data.softwareConfiguration,
          hardwareVersions: data.hardwareVersions,
          description: data.description
        }
      });
    },
    onSettled: onSoftwareUpdated,
    meta: {
      errorMessage: "E.SOFTWARE-004"
    }
  });
};

export {
  useSoftwares,
  useDeleteSoftware,
  useUploadSoftware,
  useUpdateSoftware
};
